export const AUDIO_REPORT_LOADING = 'LOADING';
export const AUDIO_REPORT_SUCCESS = 'SUCCESS';
export const AUDIO_REPORT_ERROR = 'ERROR';
